module.exports = __webpack_public_path__ + "img/KAGAMING.d01e95d8.webp";